import React from "react";

import {
  TbNumber1,
  TbNumber2,
  TbNumber3,
  TbNumber4,
  TbNumber5,
} from "react-icons/tb";
import Banner from "./Banner";

const OurProcess = () => {
  const processes = [
    {
      title: "KYC",
      icon: <TbNumber1 />,
      description:
        "Here you need to fill your personal details: Name Pan Number, Address etc, with that you need to upload your passport size photo and then register your mobile number by OTP verification.All fields are mandatory.",
      bgColor: "bg-gradient-to-r from-blue-500 to-indigo-700",
    },
    {
      title: "READ SERVICE AGREEMENT",
      icon: <TbNumber2 />,
      description:
        "Here you will see The Service Agreement click on that to expand : you need to read properly and give your consent by clicking on I Agree or I Accept, If you disagree with any single point of agreement you may Stop the process in any step. We Values Your Susceptibility. After that you may upload your original signature and click to SUBMIT for next Step",
      bgColor: "bg-gradient-to-r from-green-500 to-teal-700",
    },
    {
      title: "DOWNLOAD AGREEMENT",
      icon: <TbNumber3 />,
      description:
        'Here, You need to do three things. Download the PDF file (This is PDF format of our 1st Step to 5th Step of New Service Enrollment Process) Take a print of PDF file Named "NextEra Research Service Agreement" and Sign with blue pen on each 8 Pages and Scan the same. <a href="/NextEra_ServiceAgreement.docx" download="Service Agreement" class="text-blue-500 hover:underline"> Download</a>.',
      bgColor: "bg-gradient-to-r from-purple-500 to-pink-700",
    },
    {
      title: "UPLOAD SIGNED AGREEMENT TO VERIFY",
      icon: <TbNumber4 />,
      description:
        "Here, You will see the option to upload the SCANNED copy of Equity Services Agreement, After successfully uploaded you will see a message on screen that your Services Agreement has been sent for verification. Once verified, we will notify you through message/email on your mobile number. After approval, you will get a notification for the next step of making service charges.",
      bgColor: "bg-gradient-to-r from-orange-500 to-red-700",
    },
    {
      title: "GO FOR PAYMENT",
      icon: <TbNumber5 />,
      description:
        "Here, You will see the different bank details and UPI details for making payment of service charges. We are accepting only Net Banking Transfer, UPI Transfer, Cheque, DD, and NEFT/RTGS. Cash deposits are not allowed. After making the payment, you need to fill in the details of the same and click on submit. Once your payment is received, we will notify you through email.",
      bgColor: "bg-gradient-to-r from-cyan-500 to-blue-700",
    },
  ];

  return (
    <section className="text-green-900 py-12 md:py-16 px-4 md:px-8 lg:px-12 bg-white">
      <div className="max-w-7xl mx-auto">
        <h1 className="text-3xl md:text-4xl lg:text-5xl font-bold text-center text-green-900 mb-4">
          Our Process
        </h1>
        <div className="w-24 h-1 bg-green-600 mx-auto mb-12"></div>

        <div className="space-y-16">
          {processes.map((process, i) => (
            <div
              key={i}
              className="relative group"
            >
              {/* Step indicator */}
              <div className={`absolute -left-4 -top-4 md:-left-6 md:-top-6 h-16 w-16 md:h-20 md:w-20 rounded-full ${process.bgColor} flex items-center justify-center text-white text-2xl md:text-3xl font-bold z-10 shadow-lg`}>
                {i + 1}
              </div>

              {/* Process card */}
              <div className="bg-white border border-green-200 rounded-xl p-6 md:p-8 shadow-md transition-all duration-300 group-hover:shadow-lg group-hover:border-green-300 relative overflow-hidden">
                {/* Corner accent */}
                <div className={`absolute top-0 right-0 w-24 h-24 ${process.bgColor} opacity-10 -mr-12 -mt-12 rounded-full`}></div>

                <h3 className="text-xl md:text-2xl font-semibold text-green-800 mb-4 pl-12">
                  {process.title}
                </h3>

                <div className="prose prose-green max-w-none text-green-900 pl-12">
                  <p dangerouslySetInnerHTML={{ __html: process.description }}></p>
                </div>

                {/* Icon */}
                <div className={`absolute bottom-4 right-4 h-12 w-12 rounded-lg ${process.bgColor} flex items-center justify-center text-white text-2xl`}>
                  {process.icon}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>

      <Banner />
    </section>
  );
};

export default OurProcess;
